import React from 'react';
import CommonModal from '../CommonModal';
import Button from '../Button';
import { AlertCircle } from 'lucide-react';

interface StoreCloseModalProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    title: string;
    message: string;
    // show?: boolean;
}

export const StoreCloseModal: React.FC<StoreCloseModalProps> = ({
    open,
    onOpenChange,
    title,
    message,
    // show = true,
}) => {
    return (
        <CommonModal
            open={open}
            onOpenChange={onOpenChange}
            title={title}
            size="sm"
        >
            <div className="space-y-4">
                <div className="flex justify-center mb-2">
                    <div className="p-3 bg-red-100 rounded-full text-red-600">
                        <AlertCircle className="w-8 h-8" />
                    </div>
                </div>
                <p className="text-sm font-medium text-foreground text-center bg-secondary/5 p-3 rounded-lg border border-secondary/10">
                    {message}
                </p>
                {/* {show && <p className="text-sm text-muted-foreground text-center">
                    Please contact the administrator for more information or adjust your settings.
                </p>} */}
                <div className="flex justify-center pt-2">
                    <Button variant="primary" onClick={() => onOpenChange(false)}>Understood</Button>
                </div>
            </div>
        </CommonModal>
    );
};
